import { render, staticRenderFns } from "./InventoryTable.vue?vue&type=template&id=cff38eb8&scoped=true"
import script from "./InventoryTable.vue?vue&type=script&lang=ts"
export * from "./InventoryTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff38eb8",
  null
  
)

export default component.exports